/* Ravemark colour picker.
   Lives outside sections/duven-product.liquid so that section stays inside the
   size a single theme write can carry.

   The swatch rows are drawn INSIDE the selected bundle tier, so the shopper
   picks their colours in the same box they picked their offer. Unselected
   tiers render nothing. Because a tier is a <button>, the swatches are
   span-shaped and their clicks are caught in the capture phase and stopped, or
   choosing a colour would also re-select the tier.

   window.DvColours(root, opts) returns:
     render(units, btn) - draw rows for this tier, clear the others
     props()            - line item properties for the cart add
     ok() / nag()       - required-colour gate and its nudge
   opts: { hero, tiers, selectTier } */
window.DvColours = function(root, opts){
  var hero = opts.hero, tiers = opts.tiers || [], selectTier = opts.selectTier;
  var dead = { render: function(){}, props: function(){ return null; }, ok: function(){ return true; }, nag: function(){} };

  var box = root.querySelector('[data-dv-cols]');
  if(!box) return dead;
  var raw = box.querySelector('[data-dv-cols-data]') || root.querySelector('[data-dv-cols-data]');
  if(!raw) return dead;
  var data = {};
  try{ data = JSON.parse(raw.textContent); }catch(e){ return dead; }
  var list = data.colours || [];
  if(!list.length) return dead;

  var inputs   = box.querySelector('[data-dv-cols-inputs]');
  var mode     = box.dataset.mode;
  var word     = box.dataset.word || 'Item';
  var single   = box.dataset.single || 'Colour';
  var heading  = box.dataset.heading || '';
  var labels   = box.dataset.labels || 'auto';   // auto | text | image
  var required = box.dataset.required === '1';
  var sync     = box.dataset.sync === '1';

  var picks = [];                 // chosen colour per unit, kept across tier changes
  var current = data.selected || list[0].name;
  var curUnits = 1;
  var curBox = null;

  function byName(n){ for(var i=0;i<list.length;i++){ if(list[i].name === n) return list[i]; } return list[0]; }
  function keyFor(i, n){ return n === 1 ? single : (word + ' ' + (i + 1)); }
  function esc(s){ return String(s).replace(/"/g,'&quot;'); }

  function swatch(c, on){
    var style = c.hex ? 'background:' + c.hex : (c.thumb ? 'background-image:url(' + c.thumb + ')' : '');
    return '<span class="dvp-sw' + (on ? ' is-on' : '') + '" role="radio" tabindex="0"' +
           ' aria-checked="' + (on ? 'true' : 'false') + '" data-dv-sw data-name="' + esc(c.name) + '"' +
           ' title="' + esc(c.name) + '" aria-label="' + esc(c.name) + '" style="' + style + '"></span>';
  }

  // The row's leading element. With a photo for the chosen colour it is that
  // photo, which is far quicker to read than "Item 2"; without one it falls
  // back to the text label. 'text' and 'image' force either behaviour.
  function rowLead(i, n, chosen){
    var c = chosen ? byName(chosen) : null;
    var useImg = labels !== 'text' && c && c.thumb;
    if(labels === 'image' && !useImg) useImg = false;
    if(useImg) return '<span class="dvp-clab dvp-clab--img"><img src="' + c.thumb + '" alt="' + esc(c.name) + '" loading="lazy"></span>';
    return '<span class="dvp-clab">' + keyFor(i, n) + '</span>';
  }

  function swapHero(c){
    if(!sync || !hero || !c.img) return;
    hero.src = c.img;
    hero.removeAttribute('srcset');
    root.querySelectorAll('.dvp-thumb').forEach(function(x){ x.setAttribute('aria-current','false'); });
  }

  // Option mode: re-point every tier at the variants wearing this colour.
  function remap(name){
    var slice = (data.map || {})[name];
    if(!slice) return;
    tiers.forEach(function(t, i){
      var v = slice[i];
      if(!v) return;
      t.dataset.variant = v.id;
      t.dataset.price = v.price;
      var now = t.querySelector('.dvp-t-now'); if(now) now.textContent = v.price;
      var was = t.querySelector('.dvp-t-was'); if(was) was.textContent = v.was;
      var pct = t.querySelector('.dvp-t-pct'); if(pct) pct.textContent = v.save;
      t.disabled = !v.avail;
      t.classList.toggle('is-out', !v.avail);
    });
    var on = tiers.filter(function(t){ return t.getAttribute('aria-checked') === 'true'; })[0];
    if(on && typeof selectTier === 'function') selectTier(on);
  }

  function syncInputs(){
    if(!inputs) return;
    var html = '';
    if(mode === 'properties'){
      for(var i = 0; i < curUnits; i++){
        if(!picks[i]) continue;
        html += '<input type="hidden" name="properties[' + keyFor(i, curUnits) + ']" value="' + esc(picks[i]) + '">';
      }
    }
    inputs.innerHTML = html;
  }

  function paint(){
    if(!curBox) return;
    Array.prototype.slice.call(curBox.querySelectorAll('.dvp-crow')).forEach(function(r){
      var i = parseInt(r.dataset.row, 10);
      var chosen = mode === 'option' ? current : picks[i];
      Array.prototype.slice.call(r.querySelectorAll('[data-dv-sw]')).forEach(function(b){
        var on = b.dataset.name === chosen;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var lead = r.querySelector('.dvp-clab');
      if(lead){
        var tmp = document.createElement('span');
        tmp.innerHTML = rowLead(i, curUnits, chosen);
        r.replaceChild(tmp.firstChild, lead);
      }
      r.classList.toggle('is-empty', !chosen);
    });
    syncInputs();
  }

  function choose(idx, name){
    if(mode === 'option'){ current = name; remap(name); }
    else { picks[idx] = name; }
    swapHero(byName(name));
    paint();
  }

  function render(units, btn){
    // Only the selected tier carries the picker.
    root.querySelectorAll('[data-dv-tcols]').forEach(function(el){
      if(el !== (btn && btn.querySelector('[data-dv-tcols]'))){ el.innerHTML = ''; el.hidden = true; }
    });
    curBox = btn ? btn.querySelector('[data-dv-tcols]') : null;
    if(!curBox) return;

    var n = mode === 'option' ? 1 : Math.max(1, units || 1);
    curUnits = n;
    if(mode === 'properties' && !required){
      for(var k = 0; k < n; k++){ if(!picks[k]) picks[k] = list[0].name; }
    }

    var html = heading ? '<span class="dvp-chead">' + heading + '</span>' : '';
    for(var i = 0; i < n; i++){
      var chosen = mode === 'option' ? current : picks[i];
      html += '<span class="dvp-crow' + (chosen ? '' : ' is-empty') + '" data-row="' + i + '">' +
                rowLead(i, n, chosen) + '<span class="dvp-csw">';
      for(var j = 0; j < list.length; j++) html += swatch(list[j], list[j].name === chosen);
      html += '</span></span>';
    }
    curBox.innerHTML = html;
    curBox.hidden = false;
    syncInputs();
  }

  // Capture phase, and stopped: the swatch sits inside the tier button, so a
  // bubbling click would flip the tier as a side effect of picking a colour.
  root.addEventListener('click', function(e){
    var sw = e.target.closest ? e.target.closest('[data-dv-sw]') : null;
    if(!sw) return;
    e.preventDefault();
    e.stopPropagation();
    var row = sw.closest('.dvp-crow');
    if(row) choose(parseInt(row.dataset.row, 10), sw.dataset.name);
  }, true);

  root.addEventListener('keydown', function(e){
    if(e.key !== 'Enter' && e.key !== ' ') return;
    var sw = e.target.closest ? e.target.closest('[data-dv-sw]') : null;
    if(!sw) return;
    e.preventDefault();
    e.stopPropagation();
    var row = sw.closest('.dvp-crow');
    if(row) choose(parseInt(row.dataset.row, 10), sw.dataset.name);
  }, true);

  // Option mode already carries the colour on the variant, so repeating it as
  // a property would print it twice in the basket and on the order.
  function props(){
    if(mode !== 'properties') return null;
    var out = {}, any = false;
    for(var i = 0; i < curUnits; i++){
      if(!picks[i]) continue;
      out[keyFor(i, curUnits)] = picks[i];
      any = true;
    }
    return any ? out : null;
  }

  function ok(){
    if(mode !== 'properties' || !required) return true;
    for(var i = 0; i < curUnits; i++){ if(!picks[i]) return false; }
    return true;
  }

  function nag(){
    if(!curBox) return;
    curBox.classList.add('is-nagging');
    var first = curBox.querySelector('.dvp-crow.is-empty') || curBox;
    first.scrollIntoView({ block: 'center' });
    setTimeout(function(){ curBox.classList.remove('is-nagging'); }, 1600);
  }

  return { render: render, props: props, ok: ok, nag: nag };
};
